// @flow

import Tooltip from '@atlaskit/tooltip';
import React from 'react';

import { Tooltip as MuiTooltip } from '@material-ui/core';
import { isMobileBrowser } from '../../environment/utils';

// CUSTOM
import CustomTooltip from '../../../customise/custom/toolbar/CustomTooltip';
// END

type Props = {

    /**
     * Children of the component.
     */
    children: React$Node,

    /**
     * The text to be displayed in the tooltip.
     */
    content?: string | null,

    /**
     * The position of the tooltip relative to the element it contains.
     */
    position?: string,

    // if tooltip hide automatically even we have mouse hover, then we need to pass stay = true to stay on hover
    stay?: boolean

}

/**
 * Wrapper of AtlasKit Tooltip that doesn't render the actual tooltip in mobile browsers.
 *
 * @returns {ReactElement}
 */

// CUSTOM
const contentArray = ['Mute / Unmute', 'Start / Stop camera', 'Toggle screenshare', 'Open chat', 'Close chat', 'Raise / Lower your hand', 'Participants', 'Toggle tile view', 'Leave', 'Leave the meeting', 'Start / Stop sharing your screen', 'Settings', 'Select background', 'Audio settings', 'Video settings', 'Participants / invite people', 'Tile View/Spotlight View Selection', 'Tile View / Spotlight View Selection', 'More actions'];
// END

function TooltipWrapper({
    children,
    content,
    position,
    stay
}: Props) {
    if (isMobileBrowser()) {
        return children;
    }

    return (
        // CUSTOM
        <>
            {(contentArray.includes(content)) || stay ?
                <CustomTooltip
                    content={content}
                    position={position}>
                    {children}
                </CustomTooltip>
                :
                // END
                <Tooltip
                    content={content}
                    position={position}>
                    {children}
                </Tooltip>
                // CUSTOM
            }
        </>
        // END
    );
}

export default TooltipWrapper;

export const CustomMuiTooltip = ({ children, content }) => {
    return <MuiTooltip disableFocusListener id='mui-custom-tooltip' title={content} placement="top" >{children}</MuiTooltip>
}
